const initialState = () => ({
  phpVersions: [],
  vhostVersions: [],
})

const state = initialState

const getters = {
  phpVersions: state => state.phpVersions,
  vhostVersions: state => state.vhostVersions,
}

const mutations = {
  SET_PHP_VERSIONS (state, versions) {
    state.phpVersions = versions
  },
  SET_VHOST_VERSIONS (state, versions) {
    state.vhostVersions = versions
  },
}

const actions = {
  async getPhpVersions ({ dispatch, commit }) {
    const data = {
      uapi_module: 'LangPHP',
      uapi_function: 'php_get_installed_versions',
    }
    try {
      const response = await dispatch('cpanel_uapi', data, { root: true })
      const versions = response.payload.data?.versions ?? []
      commit('SET_PHP_VERSIONS', versions)
    } catch (e) {
      throw e
    }
  },
  async getVhostVersions ({ dispatch, commit }) {
    const data = {
      uapi_module: 'LangPHP',
      uapi_function: 'php_get_vhost_versions',
    }
    try {
      const response = await dispatch('cpanel_uapi', data, { root: true })
      const vhosts = response.payload?.data ?? []
      commit('SET_VHOST_VERSIONS', vhosts)
    } catch (e) {
      throw e
    }
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
}
